import React from 'react';
import styled from 'styled-components';

import { Locale } from '@rover/constants/src/i18n/lingui.constants';
import AlertSuccess from '@rover/icons/svg/alert-success.svg';
import Calendar from '@rover/icons/svg/calendar.svg';
import { Box, Flex, Text } from '@rover/kibble/core';
import MQ from '@rover/kibble/styles/MediaQuery';
import useI18nContext from '@rover/react-lib/src/context/useI18nContext';

export type Props = {
  featuredLabel: {
    extra?: string;
    text: string;
  };
};

const FeaturedLabel = styled(Flex)<{
  hasExtra: boolean;
}>`
  background-color: ${({ hasExtra, theme }) => (hasExtra ? theme.colors.green[100] : '')};
  border-radius: ${({ theme }) => theme.radii.secondary};
  border: ${({ hasExtra, theme }) =>
    hasExtra ? '' : `${theme.borderWidth.secondary} solid ${theme.colors.border.secondary}`};

  ${MQ.XS_DOWN.toString()} {
    min-height: 30px;
  }
`;

export const StyledAlertSuccess = styled(AlertSuccess)`
  fill: ${({ theme }) => theme.colors.green[600]};
  height: ${({ theme }) => theme.text['100'].fontSize};
  margin-right: ${({ theme }) => theme.space['1x']};
  stroke: ${({ theme }) => theme.colors.green[600]};
  width: ${({ theme }) => theme.text['100'].fontSize};
`;

export const StyledCalendar = styled(Calendar)`
  fill: ${({ theme }) => theme.textColor.primary};
  height: ${({ theme }) => theme.text['100'].fontSize};
  margin-right: ${({ theme }) => theme.space['1x']};
  stroke: ${({ theme }) => theme.textColor.primary};
  width: ${({ theme }) => theme.text['100'].fontSize};
`;

export default ({ featuredLabel: { text, extra } }: Props): React.ReactElement => {
  const { locale } = useI18nContext();
  const hasExtra = extra !== undefined;
  return (
    <FeaturedLabel
      alignItems="center"
      flexDirection="row"
      hasExtra={hasExtra}
      justifyContent="center"
      mb="4x"
      px="4x"
      py="2x"
      width="100%"
    >
      {hasExtra ? <StyledAlertSuccess /> : <StyledCalendar />}
      <Box flex={['1 1']} ml="1x">
        <Text textColor="secondary" size="100">
          {text}
          {hasExtra && extra !== '' && (
            <>
              {locale === Locale.FrFr ? ' ' : ''}: {extra}
            </>
          )}
        </Text>
      </Box>
    </FeaturedLabel>
  );
};
